const milesToMeters = (mi) => mi * 1609.34;

export const transformPayloadCoverage = (areas = []) => {

  console.log(areas);

  return areas.map((a) => {
    const isFakeId = typeof a.id === "string" && a.id.includes("_");

    return {
      ...(isFakeId ? {} : { id: a.id }), 
      location: null,
      name: a.name,
      state: a.state,
      city: a.city,
      country: a.country,
      zipCode: null,
      address: a.address,
      latitude: a.lat?.toString(),
      longitude: a.lng?.toString(),
      milesOfCoverageArea: a.radius ? milesToMeters(Number(a.radius)) : null,
      isDeleted: false,
      isAvailable: true,
      isDefault: !!a.isDefault,
      parentCoverageAreaId: null, 
      ignoreAreas: (a.ignoreAreas || []).map((ig) => {
        const isFakeIgnoreId =
          typeof ig.id === "string" && ig.id.includes("_");

        return {
          ...(isFakeIgnoreId ? {} : { id: ig.id }),
          location: null,
          name: ig.name,
          state: ig.state,
          city: ig.city,
          country: ig.country,
          zipCode: null,
          address: ig.address,
          latitude: ig.lat?.toString(),
          longitude: ig.lng?.toString(),
          milesOfCoverageArea: ig.radius ? Number(milesToMeters(Number(ig.radius)).toFixed(5)) : null,
          companyId: null,
          userId: null,
          isDeleted: false,
          isAvailable: true,
          isDefault: false,
          parentCoverageAreaId: isFakeId ? null : a.id,
        };
      }),
    };
  });
};
